import { useTranslation } from "react-i18next";
import {useForm} from "./CustomerFormComponents";
import {bindActionCreators} from "redux";
import formActionsImp from "../../../Actions/formActions";
import {useDispatch} from "react-redux";
import {UserRoles} from "../../../Constants/userRoles";
import useUserAccess from "../../../Hooks/useUserAccess";

export function CustomerForm({ form, columns, fieldParams = {} }) {
    const { hasAdminAccess } = useUserAccess();
    
    const userHasCustomerAdminRole = hasAdminAccess(UserRoles.CustomerNumber);
    const userHasInternalInfoRole = hasAdminAccess(UserRoles.InternalInfo);
    const userHasOrganizationNumberAdminRole = hasAdminAccess(UserRoles.OrganizationNumber);
    const userHasInvoiceReceiverRole = hasAdminAccess(UserRoles.InvoiceReceiver);
    
    const params = {
        userHasCustomerAdminRole,
        userHasInternalInfoRole,
        userHasOrganizationNumberAdminRole,
        userHasInvoiceReceiverRole,
        ...fieldParams
    };
    
    return (
        <form className="skynet-form container">
            <div className="row">
                {columns?.map((col, colIndex) =>
                    Array.isArray(col) ? (
                        <div key={colIndex} className="col m-0 p-0">
                            {col.map((fieldset, fieldsetIndex) => (
                                <Column
                                    key={fieldset.label || fieldsetIndex}
                                    form={form}
                                    fieldset={fieldset}
                                    fieldParams={params}
                                />
                            ))}
                        </div>
                    ) : (
                        <Column
                            key={col.label || colIndex}
                            form={form}
                            fieldset={col}
                            fieldParams={params}
                        />
                    )
                )}
            </div>
        </form>
    );
}
const Column = ({form, fieldset, fieldParams}) => {
    const dispatch = useDispatch();
    const formActions = bindActionCreators(formActionsImp, dispatch);

    const {t} = useTranslation();
    const onBlur = (field) => formActions.validateField(form, field.name);
    const onChange = (field, value) => formActions.changeMultiFormField(form, field, value);
    const {renderField, isFieldHidden, isFieldDisabled} = useForm({form, onChange, onBlur, fieldParams});
    
    return <fieldset key={fieldset.label} className="d-grid col-12 gap-16 rounded-12 p-12 shadow-10" disabled={isFieldDisabled(fieldset, fieldParams)}>
        <label className="bold">{t(fieldset.label)}</label>
        {fieldset.fields.filter(field => !isFieldHidden(field, fieldParams)).map(field => renderField(field))}
    </fieldset>
}